import {Color} from '@benchling/nucleus-ui';

export interface ActionItemCategoryColor {
  name: string;
  backgroundColor: string;
  textColor: string;
}

/**
 * The fixed colors an action item's category pill can take. Each is a light Nucleus tint with the darkest
 * shade of the same hue as text, so the label stays legible. Each token is referenced explicitly (rather
 * than looked up by name) so that unused-token analysis and renames see the usages.
 */
export const ACTION_ITEM_CATEGORY_PALETTE: ReadonlyArray<ActionItemCategoryColor> = [
  {name: 'blue', backgroundColor: Color.BLUE_100, textColor: Color.BLUE_600},
  {name: 'orange', backgroundColor: Color.ORANGE_100, textColor: Color.ORANGE_600},
  {name: 'grape', backgroundColor: Color.GRAPE_100, textColor: Color.GRAPE_600},
  {name: 'teal', backgroundColor: Color.TEAL_100, textColor: Color.TEAL_600},
  {name: 'red', backgroundColor: Color.RED_100, textColor: Color.RED_600},
  {name: 'green', backgroundColor: Color.GREEN_100, textColor: Color.GREEN_600},
  {name: 'pink', backgroundColor: Color.PINK_100, textColor: Color.PINK_600},
];

/**
 * The color for a category. It is derived from the category name alone (ignoring case and surrounding
 * whitespace), so a category keeps its color across reloads and across action items, with no stored
 * assignment. Distinct categories can share a color when there are more categories than palette entries.
 */
export function getActionItemCategoryColor(category: string): ActionItemCategoryColor {
  const normalized = category.trim().toLowerCase();
  let hash = 0;
  for (let i = 0; i < normalized.length; i++) {
    hash = (hash * 31 + normalized.charCodeAt(i)) >>> 0;
  }
  return ACTION_ITEM_CATEGORY_PALETTE[hash % ACTION_ITEM_CATEGORY_PALETTE.length];
}
